<div class="share-dialog">
  <!-- Inner wrapper -->
  <div class="share-dialog-inner">
    <!-- Header with title and close button -->
    <div class="share-dialog-header">
      <h2 class="share-dialog-title">Share</h2>
      <button
        type="button"
        class="share-dialog-close"
        (click)="onClose()"
        aria-label="Close"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#96080B"/>
          <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- Content section -->
    <div class="share-dialog-content">
    <div class="share-social-icons">
      <!-- Facebook -->
      <button
        type="button"
        class="share-social-button"
        (click)="shareToFacebook(); $event.stopPropagation()"
        aria-label="Share on Facebook"
      >
        <div class="share-social-icon">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_facebook)">
              <path d="M41 20.5C41 9.17823 31.8218 0 20.5 0C9.17823 0 0 9.17823 0 20.5C0 30.7321 7.49659 39.2131 17.2969 40.751V26.4258H12.0918V20.5H17.2969V15.9836C17.2969 10.8458 20.3575 8.00781 25.0401 8.00781C27.2829 8.00781 29.6289 8.4082 29.6289 8.4082V13.4531H27.044C24.4973 13.4531 23.7031 15.0334 23.7031 16.6546V20.5H29.3887L28.4798 26.4258H23.7031V40.751C33.5034 39.2131 41 30.7322 41 20.5Z" fill="#1877F2"/>
              <path d="M28.4798 26.4258L29.3887 20.5H23.7031V16.6546C23.7031 15.0332 24.4973 13.4531 27.044 13.4531H29.6289V8.4082C29.6289 8.4082 27.2829 8.00781 25.0399 8.00781C20.3575 8.00781 17.2969 10.8458 17.2969 15.9836V20.5H12.0918V26.4258H17.2969V40.751C18.3565 40.917 19.4274 41.0003 20.5 41C21.5726 41.0003 22.6435 40.917 23.7031 40.751V26.4258H28.4798Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_facebook">
                <rect width="41" height="41" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <span class="share-social-label">Facebook</span>
      </button>

      <!-- LinkedIn -->
      <button
        type="button"
        class="share-social-button"
        (click)="shareToLinkedIn(); $event.stopPropagation()"
        aria-label="Share on LinkedIn"
      >
        <div class="share-social-icon">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M31.3906 0H9.60938C4.30226 0 0 4.30226 0 9.60938V31.3906C0 36.6977 4.30226 41 9.60938 41H31.3906C36.6977 41 41 36.6977 41 31.3906V9.60938C41 4.30226 36.6977 0 31.3906 0Z" fill="#0A66C2"/>
              <path d="M29.5833 34.8636H34.271C34.4409 34.8636 34.6038 34.7961 34.724 34.676C34.8441 34.5559 34.9116 34.393 34.9117 34.2231L34.9141 24.3188C34.9141 19.142 33.7986 15.163 27.749 15.163C25.4493 15.0774 23.2806 16.2629 22.1104 18.2424C22.1046 18.2521 22.0959 18.2595 22.0856 18.2637C22.0752 18.2679 22.0637 18.2686 22.0529 18.2657C22.0421 18.2628 22.0326 18.2564 22.0258 18.2475C22.0189 18.2387 22.0152 18.2278 22.0151 18.2167V16.2815C22.0151 16.1116 21.9476 15.9486 21.8274 15.8285C21.7073 15.7084 21.5444 15.6409 21.3745 15.6409H16.9258C16.7559 15.6409 16.5929 15.7084 16.4728 15.8285C16.3527 15.9486 16.2852 16.1116 16.2852 16.2815V34.2222C16.2852 34.3921 16.3527 34.555 16.4728 34.6752C16.5929 34.7953 16.7559 34.8628 16.9258 34.8628H21.6132C21.7832 34.8628 21.9461 34.7953 22.0662 34.6752C22.1864 34.555 22.2539 34.3921 22.2539 34.2222V25.3539C22.2539 22.8463 22.7295 20.4178 25.8383 20.4178C28.9029 20.4178 28.9426 23.2872 28.9426 25.5163V34.223C28.9426 34.3929 29.0101 34.5558 29.1303 34.676C29.2504 34.7961 29.4134 34.8636 29.5833 34.8636ZM6.08594 9.5498C6.08594 11.4499 7.65018 13.0133 9.55044 13.0133C11.4502 13.0132 13.0135 11.4488 13.0135 9.549C13.0132 7.64922 11.4497 6.08594 9.5498 6.08594C7.64938 6.08594 6.08594 7.6497 6.08594 9.5498ZM7.20046 34.8636H11.8942C12.0641 34.8636 12.227 34.7961 12.3472 34.676C12.4673 34.5558 12.5348 34.3929 12.5348 34.223V16.2815C12.5348 16.1116 12.4673 15.9486 12.3472 15.8285C12.227 15.7084 12.0641 15.6409 11.8942 15.6409H7.20046C7.03056 15.6409 6.86762 15.7084 6.74747 15.8285C6.62733 15.9486 6.55984 16.1116 6.55984 16.2815V34.223C6.55984 34.3929 6.62733 34.5558 6.74747 34.676C6.86762 34.7961 7.03056 34.8636 7.20046 34.8636Z" fill="white"/>
            </g>
          </svg>
        </div>
        <span class="share-social-label">LinkedIn</span>
      </button>

      <!-- X (Twitter) -->
      <button
        type="button"
        class="share-social-button"
        (click)="shareToX(); $event.stopPropagation()"
        aria-label="Share on X"
      >
        <div class="share-social-icon">
          <svg width="36" height="42" viewBox="0 0 36 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M5.14286 2.57143C2.30625 2.57143 0 4.87768 0 7.71429V33.4286C0 36.2652 2.30625 38.5714 5.14286 38.5714H30.8571C33.6937 38.5714 36 36.2652 36 33.4286V7.71429C36 4.87768 33.6937 2.57143 30.8571 2.57143H5.14286ZM29.017 9.32143L20.6759 18.8518L30.4875 31.8214H22.8054L16.7946 23.9545L9.90804 31.8214H6.09107L15.0107 21.6241L5.60089 9.32143H13.4759L18.9161 16.5134L25.2 9.32143H29.017ZM25.9795 29.5393L12.3268 11.483H10.0527L23.858 29.5393H25.9795Z" fill="black"/>
            </g>
          </svg>
        </div>
        <span class="share-social-label">X</span>
      </button>
    </div>

      <!-- Page link section -->
    <div class="share-link-section">
      <label class="share-link-label">Page Link</label>
      <div class="share-link-container">
        <span class="share-link-url">{{ data.url }}</span>
        <button
          type="button"
          class="share-copy-button"
          (click)="copyLink(); $event.stopPropagation()"
          [attr.aria-label]="copySuccess ? 'Link copied' : 'Copy link'"
        >
          @if (copySuccess) {
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.25 9.625L2.625 7L1.75 7.875L5.25 11.375L12.25 4.375L11.375 3.5L5.25 9.625Z" fill="#757575"/>
            </svg>
          } @else {
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.91667 0.583344H2.91667C2.18333 0.583344 1.58333 1.18334 1.58333 1.91668V10.0833H2.91667V1.91668H9.91667V0.583344ZM11.9167 3.25001H5.58333C4.85 3.25001 4.25 3.85001 4.25 4.58334V12.0833C4.25 12.8167 4.85 13.4167 5.58333 13.4167H11.9167C12.65 13.4167 13.25 12.8167 13.25 12.0833V4.58334C13.25 3.85001 12.65 3.25001 11.9167 3.25001ZM11.9167 12.0833H5.58333V4.58334H11.9167V12.0833Z" fill="#757575"/>
            </svg>
          }
        </button>
      </div>
    </div>
    </div>
  </div>
</div>
